__turbopack_context__.v({
  "l3": "dJ6-KG_l3",
  "loader": "dJ6-KG_loader",
  "shimmer": "dJ6-KG_shimmer",
  "text-bar-sweep": "dJ6-KG_text-bar-sweep",
});
